import {forwardRef, type ComponentPropsWithoutRef, type ReactNode} from 'react';
import {PlusIcon} from 'lucide-react';
import {cn} from '@chekinapp/ui';

type Props = ComponentPropsWithoutRef<'button'> & {
  hint?: ReactNode;
};

const AddSlotButton = forwardRef<HTMLButtonElement, Props>(
  ({hint, className, children, type = 'button', ...props}, ref) => (
    <button
      ref={ref}
      type={type}
      className={cn(
        'flex min-h-[var(--add-slot-min-height,48px)] w-full flex-wrap items-center justify-center gap-x-2 gap-y-0.5 px-3.5 py-2 text-center',
        'rounded-[var(--button-radius)] border-[1.5px] border-dashed border-[color:var(--chekin-neutral-400)] bg-transparent',
        'text-[14px] font-semibold leading-5 text-[color:var(--chekin-color-brand-blue)]',
        'transition-colors hover:border-[color:var(--chekin-color-brand-blue)] hover:bg-[var(--chekin-blue-50)]',
        'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--chekin-color-brand-blue)]',
        'disabled:pointer-events-none disabled:opacity-50',
        className,
      )}
      {...props}
    >
      <span className="inline-flex items-center gap-2 [&_svg]:size-4 [&_svg]:shrink-0">
        <PlusIcon aria-hidden="true" strokeWidth={2.4} />
        {children}
      </span>
      {hint ? (
        <span className="text-[12px] font-medium leading-4 text-[color:var(--chekin-text-secondary)]">
          {hint}
        </span>
      ) : null}
    </button>
  ),
);
AddSlotButton.displayName = 'AddSlotButton';

export {AddSlotButton};
